const accountTypeTransfeeraAPI = require('../accountType');

const accountType = {
  checking: 0,
  salary: 1,
  savings: 2,
  payment: 3,
  convertToJDPI(type) {
    switch (type) {
      case accountTypeTransfeeraAPI.CONTA_CORRENTE:
        return this.checking;
      case accountTypeTransfeeraAPI.CONTA_SALARIO:
        return this.salary;
      case accountTypeTransfeeraAPI.CONTA_POUPANCA:
        return this.savings;
      case accountTypeTransfeeraAPI.CONTA_PAGAMENTO:
        return this.payment;
      default:
        throw new Error('Invalid account type to convert to JDPI');
    }
  },
  convertToTransfeera(type) {
    switch (type) {
      case this.checking:
        return accountTypeTransfeeraAPI.CONTA_CORRENTE;
      case this.salary:
        return accountTypeTransfeeraAPI.CONTA_SALARIO;
      case this.savings:
        return accountTypeTransfeeraAPI.CONTA_POUPANCA;
      case this.payment:
        return accountTypeTransfeeraAPI.CONTA_PAGAMENTO;
      default:
        throw new Error('Invalid account type to convert from JDPI');
    }
  }
};

module.exports = accountType;
